import React from 'react'
import { connect } from 'react-redux'
import { Trans } from 'react-i18next'
import { find } from 'lodash'

import { Format } from 'services/Dates'
import { getPositionName, getUserName } from 'services/Utilities'
import { List } from 'ui'

import { t } from 'translations'

const ShiftEligibilitySummary = ({ actionButton, contactUsers, contactUserId, shift: { _id, positionId, start, end, contactListData: { takenBy } = {} } }) => {
  const { flags: { shiftFlags = {} } = {} } = find(contactUsers, { _id: contactUserId })

  const { isEligible, forcedBy } = shiftFlags[_id]
  return (
    <List.Item className="d-flex">
      <div>
        <Trans t={t} i18nKey={`manager.contactLists.EVENT_SUMMARY`}>
          <b>
            {{ start: Format(start, { outFormat: 'humanDateTimeCompact' }).slice(0, -1) }}
            {{ end: Format(end, { outFormat: 'time' }) }}
          </b>
          {{ positionName: getPositionName(positionId) }}
        </Trans>
        {takenBy ? (
          <small className="font-weight-bold d-block text-success">{t('manager.contactLists.TAKEN_BY', { takenBy: getUserName(takenBy) })}</small>
        ) : null}
        <div>
          <small className={`mr-1 ${isEligible ? 'text-success' : 'text-danger'}`}>
            {t(`manager.contactLists.CONTACT_USER_SHIFT_ELIGIBILITY_MODAL.${isEligible ? 'ELIGIBLE' : 'NOT_ELIGIBLE'}${forcedBy ? '_FORCED_BY' : ''}`, {
              forcedBy: getUserName(forcedBy)
            })}
          </small>
          <small className="text-warning">
            {Object.keys(shiftFlags[_id])
              .filter(issue => !['reasons', 'isEligible', 'forcedBy', 'forcedEligible'].includes(issue))
              .map(issue => t(`manager.schedule.EDIT_MODAL.USER_FLAGS_SHORT.${issue}`))
              .join(', ')}
          </small>
        </div>
      </div>
      <div className="ml-auto">{actionButton}</div>
    </List.Item>
  )
}
const mapStateToProps = ({ contactLists }) => ({ contactUsers: contactLists.currentContactUsers })

export default connect(mapStateToProps)(ShiftEligibilitySummary)
